import { render, staticRenderFns } from "./order-status-message.vue?vue&type=template&id=5ea9a45c"
import script from "./order-status-message.vue?vue&type=script&lang=js"
export * from "./order-status-message.vue?vue&type=script&lang=js"
import style0 from "./order-status-message.vue?vue&type=style&index=0&id=5ea9a45c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports